import type { TextColor, TextWeight } from "@porsche-design-system/components-react"
import { PText } from "@porsche-design-system/components-react"
import type { DateView } from "@slfinrtl/ui-bff-routes"
import { Warning } from "../warning/Warning"

interface DateProps {
	color?: TextColor
	ellipsis?: boolean
	size?: "xs"
	view: DateView
	weight?: TextWeight
}

export const Date = ({ color, size, view, ...rest }: DateProps) =>
	view.warning ? (
		<Warning {...rest} hint={view.warning} label={view.value} />
	) : (
		<PText {...rest} color={color} size={size}>
			{view.value}
		</PText>
	)
